<div class="bg-primary h-100 w-100 row g-0 justify-content-center">
  <div class="col-auto align-self-center">
    <div class="logo text-center text-white py-5">
      <era-pairing-challenge></era-pairing-challenge>
    </div>
  </div>
</div>